import { useState, useEffect, useRef, useMemo } from 'react';
import React from 'react';
import {
    Card,
    Container,
    Grid,
    Typography,
    TextField,
    Button,
    Select,
    FormControl,
    InputLabel,
    MenuItem,
} from '@mui/material';
import axios from 'axios';
//import { DecodeHintType, useZxing } from 'react-zxing';
import {
    BarcodeFormat,
    BrowserMultiFormatReader,
    DecodeHintType,
    NotFoundException,
    Result,
} from '@zxing/library';

function Scan() {
    const [barcode, setBarcode] = useState('');
    const [produit, setProduit] = useState(null);
    const [devices, setDevices] = useState([]);
    const [deviceId, setDeviceId] = useState(null);

    const getDeviceType = () => {
        const ua = navigator.userAgent;
        if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
            return 'tablet';
        }
        if (
            /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
                ua
            )
        ) {
            return 'mobile';
        }
        return 'desktop';
    };

    function strUcFirst(str) {
        return str[0].toUpperCase() + str.slice(1);
    }

    function handleSearch() {
        axios
            .get(
                `https://world.openfoodfacts.net/api/v3/product/${barcode}?cc=fr&lc=fr&fields=code%2Ccategories%2Cbrands_tags%2Cproduct_name_fr%2Cproduct_quantity%2Cproduct_quantity_unit%2Cquantity%2Cnutriscore_grade%2Cimage_url%2Cimage_front_url`
            )
            .then((reponse) => {
                return { ...reponse.data };
            })
            .then((data) => {
                if (data?.result?.id === 'product_found') {
                    let product = data?.product;
                    product.categories = product.categories
                        .split(',')
                        .map((item) => item.trim());
                    setProduit(product);
                }
            });
    }

    const codeReader = new BrowserMultiFormatReader();

    useEffect(() => {
        if (getDeviceType() != 'desktop') {
            codeReader.listVideoInputDevices().then((vid) => {
                setDevices(vid);
                setDeviceId(vid[0].deviceId);
                handleChangeDevice(vid[0].deviceId);
            });
        }
    }, []);
    console.log(document.getElementById('video'));
    const handleChangeDevice = (device) => {
        codeReader.decodeFromVideoDevice(device, 'video', (result, err) => {
            if (result) {
                console.log(result);
                setBarcode(result?.text);
            }
            if (err && !(err instanceof NotFoundException)) {
                console.error(err);
            }
        });
    };

    return (
        <>
            <Card
                sx={{
                    p: 2,
                    mx: { xs: 4, lg: 12 },
                    mt: 4,
                    mb: 4,
                }}
            >
                <Container sx={{ mt: 6 }}>
                    <Grid container spacing={3}>
                        <Typography variant='h5'>
                            Chercher un produit
                        </Typography>
                        {getDeviceType() != 'desktop' && (
                            <>
                                {devices.length > 0 && (
                                    <FormControl fullWidth>
                                        <InputLabel id='demo-simple-select-label'>
                                            Appareil
                                        </InputLabel>
                                        <Select
                                            labelId='demo-simple-select-label'
                                            id='demo-simple-select'
                                            value={deviceId || ''}
                                            label='Appareil'
                                            onChange={(event) => {
                                                setDeviceId(event.target.value);
                                                handleChangeDevice(
                                                    event.target.value
                                                );
                                            }}
                                        >
                                            {devices.map((el, index) => (
                                                <MenuItem
                                                    key={index}
                                                    value={el?.deviceId}
                                                >
                                                    {el.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                )}
                                <video
                                    id='video'
                                    width='300'
                                    height='200'
                                    style={{ border: '1px solid gray' }}
                                ></video>
                            </>
                        )}

                        {/* {!barcode && deviceId && (

                        )} */}

                        {/* <video
                            width='300'
                            ref={ref ?? null}
                            style={{ border: '2px black solid' }}
                        /> */}
                        <Grid item xs={12}>
                            <TextField
                                id='input'
                                label={'Code-barre'}
                                value={barcode}
                                onChange={(event) =>
                                    setBarcode(event.target.value)
                                }
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Button
                                variant='contained'
                                disabled={barcode.length < 5}
                                onClick={handleSearch}
                            >
                                Chercher
                            </Button>
                            <Button
                                variant='contained'
                                disabled={barcode.length < 13}
                                onClick={() => {
                                    setBarcode('');
                                    setProduit(null);
                                }}
                            >
                                Effacer
                            </Button>
                        </Grid>
                        {produit && (
                            <>
                                <Grid item xs={12} md={9}>
                                    <Typography variant='h4' component='div'>
                                        {produit?.product_name_fr
                                            ? strUcFirst(
                                                  produit?.product_name_fr
                                              )
                                            : ''}{' '}
                                        {produit?.quantity
                                            ? `- ${produit?.quantity}`
                                            : ''}
                                    </Typography>
                                    <Typography variant='h5' component='div'>
                                        {produit?.brands_tags
                                            ? produit?.brands_tags[0].toUpperCase()
                                            : ''}
                                    </Typography>
                                    <Typography variant='h6' component='div'>
                                        {produit?.nutriscore_grade &&
                                        produit?.nutriscore_grade !=
                                            'unknown' &&
                                        produit?.nutriscore_grade !=
                                            'not-applicable'
                                            ? `Nutri score : ${produit?.nutriscore_grade.toUpperCase()}`
                                            : ''}
                                    </Typography>
                                    <ul>
                                        {produit?.categories
                                            ?.filter(
                                                (el) => !el.includes('en:')
                                            )
                                            .map((item, index) => (
                                                <li key={index}>{item}</li>
                                            ))}{' '}
                                    </ul>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    {produit?.image_front_url && (
                                        <img
                                            src={produit?.image_front_url}
                                            //width={200}
                                            style={{
                                                maxWidth: 250,
                                                maxHeight: 250,
                                            }}
                                        />
                                    )}
                                </Grid>
                            </>
                        )}

                        <Grid item xs={12} lg={4}></Grid>
                    </Grid>
                </Container>
            </Card>
        </>
    );
}

export default Scan;
